var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "satisfaction-analysis-table-container" }, [
    _c(
      "div",
      [
        _c(
          "el-alert",
          {
            staticStyle: {
              "background-color": "#ffd643",
              color: "#4b4b4b",
              "margin-bottom": "10px",
            },
            attrs: { closable: false, type: "info", effect: "dark" },
          },
          [
            _c("template", { slot: "title" }, [
              _vm._v(
                " 1、滿意度定義 ：對旅遊的整體滿意度調查「滿意」之定義－採5分量表問卷，以達4分為滿意"
              ),
              _c("br"),
              _vm._v(
                " 2、滿意度計算公式 ：(非常不滿意次數*1分+不太滿意*2分+普通*3分+滿意*4分+非常滿意*5分)/總次數"
              ),
              _c("br"),
              _vm._v(" 3、資料來源：智遊旅程-團體旅遊app "),
            ]),
          ],
          2
        ),
        _vm.currentSatisfactionAnalysis
          ? _c(
              "el-descriptions",
              {
                staticClass: "margin-top",
                staticStyle: { margin: "5px", border: "2px solid #ccc" },
                attrs: {
                  labelStyle: { "text-align": "left", "font-size": "12px" },
                  contentStyle: { "text-align": "center" },
                  title: "",
                  column: 4,
                  size: "medium",
                  border: "",
                },
              },
              [
                _c(
                  "el-descriptions-item",
                  [
                    _c("template", { slot: "label" }, [
                      _c("i", { staticClass: "el-icon-user" }),
                      _vm._v(" 填寫數量 "),
                    ]),
                    _c("el-tag", { attrs: { size: "small" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.currentSatisfactionAnalysis.userReplyCount
                          ) +
                          "/" +
                          _vm._s(_vm.currentSatisfactionAnalysis.userCount)
                      ),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-descriptions-item",
                  [
                    _c("template", { slot: "label" }, [
                      _c("i", { staticClass: "el-icon-tickets" }),
                      _vm._v(" 整體滿意度 "),
                    ]),
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          size: "small",
                          type: _vm.getSatisfactionAnalysisStyle(
                            _vm.currentSatisfactionAnalysis
                              .totalSatisfactionPoint,
                            _vm.currentSatisfactionAnalysis.kind
                          ),
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.currentSatisfactionAnalysis
                                .totalSatisfactionPoint
                            )
                        ),
                      ]
                    ),
                  ],
                  2
                ),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
    _c(
      "div",
      { staticStyle: { padding: "10px" } },
      [
        _vm.currentSatisfactionAnalysis &&
        _vm.currentSatisfactionAnalysis.topicList.length > 0
          ? _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  "cell-style": _vm.cellStyleSet,
                  size: "mini",
                  data: _vm.currentSatisfactionAnalysis.topicList,
                  border: "",
                  height: "100%",
                  "header-cell-style": { textAlign: "center" },
                },
              },
              [
                _c("el-table-column", {
                  attrs: { align: "left", label: "題    目", width: "230" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(scope.row.topicDescription)),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    868327777
                  ),
                }),
                _vm._l(
                  _vm.currentSatisfactionAnalysis.options,
                  function (item) {
                    return _c(
                      "el-table-column",
                      {
                        key: item.optionID,
                        attrs: {
                          align: "center",
                          width: "200",
                          label: item.optionDescription,
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "次數",
                            width: "120",
                            prop: JSON.stringify({
                              property: "count",
                              key: item.optionDescription,
                            }),
                            formatter: _vm.cellFormatter,
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "百分比",
                            width: "120",
                            prop: JSON.stringify({
                              property: "percentage",
                              key: item.optionDescription,
                            }),
                            formatter: _vm.cellFormatter,
                          },
                        }),
                      ],
                      1
                    )
                  }
                ),
                _c(
                  "el-table-column",
                  {
                    attrs: { align: "center", label: "滿意度" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-tag",
                                {
                                  staticClass: "colorbase",
                                  staticStyle: { "font-size": "18px" },
                                  attrs: {
                                    size: "medium",
                                    type: _vm.getSatisfactionAnalysisStyle(
                                      scope.row.satisfactionAnalysis,
                                      _vm.currentSatisfactionAnalysis.kind
                                    ),
                                  },
                                },
                                [_vm._v(_vm._s(scope.row.satisfactionAnalysis))]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1685664696
                    ),
                  },
                  [void 0],
                  2
                ),
              ],
              2
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }